export default "__VITE_ASSET__e85f0e7f__"